import { Survey, SurveyForm, SurveyPhase } from '../types'

export const SUBMITTED_SURVEY_FORM: SurveyForm = {
  welcomeScreens: [
    {
      title: 'Already submitted',
      description: 'This form has already been submitted. Please contact your care team if you have any questions.',
      nextButtonTitle: 'Home',
      id: 'Already_submitted',
    },
  ],
  questionScreens: [],
  followUpScreens: [],
}

export const getFirstSurveyScreens = (survey?: Survey): SurveyPhase => {
  const dataFormStringified = survey?.form || null
  const form: SurveyForm | null = dataFormStringified ? JSON.parse(dataFormStringified) : null
  
  if (!survey) {
    return 'Welcome'
  }
  if (survey.completedOn) {
    return 'Welcome'
  }
  if (form?.welcomeScreens?.length) {
    return 'Welcome'
  }
  return 'Questions'
}
